import * as yaml from 'js-yaml';

import { type ColumnDefinition } from './ColumnDefinitionBuilder';

interface YamlTemplateColumn {
  id: string;
  prompt: string;
}

interface YamlTemplate {
  title?: string;
  initialTask?: string;
  tableDefinition?: {
    columns?: YamlTemplateColumn[];
  };
}

export interface ParsedYamlTemplate {
  title: string;
  initialTask: string;
  columns: ColumnDefinition[];
  enableTableExtraction: boolean;
}

export function parseYamlTemplate(content: string): ParsedYamlTemplate {
  const parsed = yaml.load(content);

  if (!parsed || typeof parsed !== 'object') {
    throw new Error('Invalid YAML: file must contain a YAML object');
  }

  const template = parsed as YamlTemplate;

  if (!template.title && !template.initialTask && !template.tableDefinition) {
    throw new Error(
      'Invalid template: must contain at least one of title, initialTask, or tableDefinition',
    );
  }

  const columns: ColumnDefinition[] = [];
  let enableTableExtraction = false;

  if (template.tableDefinition?.columns && Array.isArray(template.tableDefinition.columns)) {
    enableTableExtraction = template.tableDefinition.columns.length > 0;
    const invalidCol = template.tableDefinition.columns.find(
      (col) => typeof col.id !== 'string' || typeof col.prompt !== 'string',
    );
    if (invalidCol) {
      throw new Error(
        'Invalid column: each column must have string "id" and "prompt" fields',
      );
    }
    columns.push(
      ...template.tableDefinition.columns.map((col) => ({
        id: col.id,
        prompt: col.prompt,
        _key: `col-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      })),
    );
  }

  return {
    title: template.title ?? '',
    initialTask: template.initialTask ?? '',
    columns,
    enableTableExtraction,
  };
}
